<script>
import DocumentDetailsParcel from './DocumentDetailsParcel.vue'
import DocumentDetailsProperties from './DocumentDetailsProperties.vue'
import DocumentDetailsAttachments from './DocumentDetailsAttachments.vue'
import DocumentDetailsDuplicates from './DocumentDetailsDuplicates.vue'
import DocumentDetailsCoverSheet from './DocumentDetailsCoverSheet.vue'
import documentDetailsJson from '@/data/json/document-validation/documentDetails.json'

export default {
  components: {
    DocumentDetailsParcel,
    DocumentDetailsProperties,
    DocumentDetailsAttachments,
    DocumentDetailsDuplicates,
    DocumentDetailsCoverSheet
  },
  props: {
    item: { type: Object },
    canDelete: { type: Boolean },
    order: { type: [Object, Array] }
  },
  data() {
    return {
      content: documentDetailsJson,
      panels: [0, 1, 2, 3]
    }
  },
  created() {
    const { duplicates, attachments } = this.item
    if (attachments.length && duplicates.length) this.panels = [3]
    if (!attachments.length && duplicates.length) this.panels = [2]
  }
}
</script>
<template>
  <v-card>
    <DialogBaseColoredTitle color="primary"> Details</DialogBaseColoredTitle>
    <DialogBaseCloseIcon color="white" @click="$emit('close')" />
    <v-divider />
    <v-expansion-panels v-model="panels" multiple>
      <DocumentDetailsParcel :item="item" :content="content" />
      <DocumentDetailsProperties :item="item" :content="content" />
      <DocumentDetailsAttachments
        :item="item"
        :content="content"
        :order="order"
        :can-delete="canDelete"
        @deleted="$emit('itemsDeleted')"
      />
      <DocumentDetailsDuplicates
        :item="item"
        :content="content"
        :can-delete="canDelete"
        @deleted="$emit('itemsDeleted')"
      />
      <DocumentDetailsCoverSheet
        :item="item"
        :content="content"
        :order="order"
        @cover-sheet-deleted="$emit('coverSheetDeleted')"
      />
    </v-expansion-panels>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn id="close" color="primary" @click="$emit('close')">
        {{ $t('button.close') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<style lang="scss" scoped>
.v-list-item {
  min-height: 28px;
}
.v-list-item__content {
  padding: 0 !important;
}
</style>
